<template>
  <div>
    <b-card title="Refund Requests">
      <!-- search input -->

      <b-row class="mb-1">
        <!-- search input -->
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filter-refunds
              variant="outline-primary"
              class="d-flex text-primary"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered === true"
            class="d-flex justify-content-center"
          >
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="search"
            />
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <b-link
            v-if="props.column.field === 'refundReferenceCode'"
            :to="{
              name: 'refundRequest-details',
              params: {
                id: props.row.id,
              },
            }"
            target="_blank"
          >
            <span class="align-middle ml-50">{{
              props.row.refundReferenceCode
            }}</span>
          </b-link>
          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'refundStatus'">
            <span>
              <b-badge
                v-if="props.row.refundStatus === 0"
                pill
                variant="info"
                class="text-white"
              >
                Not Requested
              </b-badge>

              <b-badge
                v-else-if="props.row.refundStatus === 1"
                pill
                variant="warning"
                class="text-white"
              >
                Pending
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 2"
                pill
                variant="light-success"
                class="text-white"
              >
                Submitted
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 3"
                pill
                variant="success"
                class="text-white"
              >
                Request Approved
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 4"
                pill
                variant="light-info"
                class="text-white"
              >
                Sent
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 5"
                pill
                variant="danger"
                class="text-white"
              >
                Request Rejected
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 6"
                pill
                variant="primary"
                class="text-white"
              >
                Completed
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 8"
                pill
                variant="light-danger"
                class="text-white"
              >
                Cancelled
              </b-badge>
              <b-badge v-else pill variant="info">
                {{ props.row.refundStatus }}
              </b-badge>
            </span>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-row v-if="props.row.paymentStatus !== 3">
                <!-- v-else-if="props.row.Payment_Status==='pending'" -->
                <b-dropdown
                  variant="link"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>

                  <b-dropdown-item
                    variant="warning"
                    :to="{
                      name: 'refundRequest-details',
                      params: {
                        refundrequest: props.row,
                        id: props.row.id,
                      },
                    }"
                  >
                    <feather-icon icon="BookIcon" class="mr-50" />
                    <span>Details</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    variant="primary"
                    v-if="$can('GetOrderRefundWorkflowHistory', 'Refund')"
                    @click="fetchRefundWorkFLowHistory(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CalendarIcon" />
                    <span>Approval History</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="primary"
                    v-if="$can('GetRefundHistory', 'Refund')"
                    @click="fetchRefundHistory(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CalendarIcon" />
                    <span>Refund History</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="success"
                    v-if="
                      $can('CompleteAction', 'Refund') &&
                      (props.row.refundStatus === 1 ||
                        props.row.refundStatus === 3)
                    "
                    @click="completeRefundRequest(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Complete Refund Request</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="success"
                    v-if="
                      props.row.refundStatus === 6 &&
                      $can('CompleteAction', 'Refund')
                    "
                    @click="resendRefundConfirmationMerchant(props.row.id)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Resend to Merchant</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="success"
                    v-if="
                      props.row.refundStatus === 3 &&
                      $can('CompleteAction', 'Refund')
                    "
                    @click="resendRefundConfirmationBank(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Resend to Bank</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    variant="warning"
                    v-if="
                      props.row.refundStatus != 6 &&
                      $can('CompleteAction', 'Refund')
                    "
                    @click="cancelRefund(props.row)"
                  >
                    <feather-icon class="mr-50" icon="CheckIcon" />
                    <span>Cancel</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </span>
          </span>
          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-modal
        id="modal-filter-refunds"
        title="Filter Reconcilation"
        ok-title="Search"
        cancel-variant="outline-secondary"
        size="lg"
        @ok="filterRefundRequests"
      >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group label="Order Id">
                <b-form-input
                  id="filterflyGateOrderId-input"
                  v-model="filterflyGateOrderId"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Reference Number">
                <b-form-input
                  id="filtervendorTxnRefNumber-input"
                  v-model="filtervendorTxnRefNumber"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Custom Order Code">
                <b-form-input
                  id="filtercustomOrderCode-input"
                  v-model="filtercustomOrderCode"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Paid FOP">
                <b-form-select
                  v-model="selectedPaidPaymentOptions"
                  :options="paidPaymentOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refunded FOP">
                <b-form-select
                  v-model="selectedRefundedPaymentOptions"
                  :options="refundedPaymentOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="From Amount">
                <b-form-input
                  id="fromRequestedAmount-input"
                  v-model.number="fromRequestedAmount"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="To Amount">
                <b-form-input
                  id="toRequestedAmount-input"
                  v-model.number="toRequestedAmount"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refund Reference Code">
                <b-form-input
                  id="filterrefundReferenceCode-input"
                  v-model="filterrefundReferenceCode"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refund Merchant Request Code">
                <b-form-input
                  id="filterrefundMerchantRequestCode-input"
                  v-model="filterrefundMerchantRequestCode"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refund Reference Code From Bank">
                <b-form-input
                  id="refundReferenceCodeFromBank-input"
                  v-model="refundReferenceCodeFromBank"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refund Status">
                <b-form-select
                  v-model="selectedRefundStatus"
                  :options="refundStatusOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refund Request Date Range">
                <flat-pickr
                  v-model="trxnDateRange"
                  class="form-control"
                  :config="{ mode: 'range', maxDate: 'today' }"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Refunded Date Range">
                <flat-pickr
                  v-model="trxnDateRangePaidDate"
                  class="form-control"
                  :config="{ mode: 'range', maxDate: 'today' }"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Country" label-for="country">
                <b-form-select
                  id="country-input"
                  v-model="country"
                  :options="countryOptions"
                  @change="getByCountry"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Currency" label-for="currency">
                <b-form-select
                  id="currency-input"
                  v-model="currency"
                  :options="currencyOptions"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>

      <b-modal
        id="modal-Refund-workflow-history"
        title="Refund WorkFlow History"
        hide-footer
        size="lg"
        scrollable
      >
        <h3>
          Refund Work Flow History for Order Code :{{
            refundworkflowHistory[refundworkflowHistory.length - 1]
          }}
        </h3>
        <hr />
        <b-row>
          <b-table
            striped
            :items="refundworkflowHistory"
            :fields="refundWorkFlowHistoryfield"
            :busy="isLoading"
            caption-top
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-row>
      </b-modal>

      <b-modal
        id="modal-Refund-history"
        title="Refund History"
        hide-footer
        size="lg"
        scrollable
      >
        <h3>
          Refund History for Order Code :{{
            refundhistories[refundhistories.length - 1]
          }}
        </h3>
        <hr />
        <b-row>
          <b-table
            striped
            :items="refundhistories"
            :fields="refundHistoryfield"
            :busy="isLoading"
            caption-top
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-row>
      </b-modal>

      <b-modal
        id="modal-complete-refund-request"
        title="Complete Reund Request"
        cancel-variant="outline-secondary"
        @ok="handleOk"
      >
        <form ref="completeform">
          <b-form-group label="Refund Reference Code From Bank">
            <b-form-input
              id="filterflyGateOrderId-input"
              v-model="completeRefundRequestfield.RefundReferenceCodeFromBank"
              :state="
                completeRefundRequestfield.RefundReferenceCodeFromBank.length >
                0
              "
              required
            />
          </b-form-group>
        </form>
      </b-modal>

      <b-modal
        id="modal-cancel-refund"
        title="Cancel Refund"
        ancel-variant="outline-secondary"
        @ok="submitCancelRefund"
      >
        <form ref="completeform">
          <b-form-group label="Reason for cancellation">
            <b-form-input
              v-model="cancelRefundField.cancelRemark"
              placeholder="Enter reason"
              :state="cancelRefundField.cancelRemark.length > 0"
              required
            ></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCardBody,
  BTable,
  BLink,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";
import store from "@/store";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  name: "Users",
  components: {
    BRow,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCol,
    BButton,
    BForm,
    BModal,
    BCardBody,
    BTable,
    BSpinner,
    BLink,
    flatPickr,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  props: {
    proprefundHistory: {
      type: Object,
    },
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      trxnDateRange: "",
      trxnStartDate: "",
      trxnEndDate: "",
      selectedOrder: "",
      filterflyGateOrderId: "",
      filtervendorTxnRefNumber: "",
      filtercustomOrderCode: "",
      filterrefundReferenceCode: "",
      filterrefundMerchantRequestCode: "",
      trxnDateRangePaidDate: "",
      trxnStartDatePaidDate: "",
      trxnEndDatePaidDate: "",
      country: "",
      currency: "",
      columns: [
        {
          label: "Refund Requested Date",
          field: "refundRequestedDateString",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Fly Gate OrderId",
          field: "flyGateOrderId",
        },
        {
          label: "Paid FOP",
          field: "paidFOP",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "order Amount",
          field: "orderAmount",
          type: "number",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
          type: "number",
        },
        {
          label: "Vendor TxnRef. Number",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Bank Refund Reference",
          field: "refundReferenceCodeFromBank",
        },
        {
          label: "Refund Status",
          field: "refundStatus",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      refundWorkFlowHistoryfield: [
        {
          key: "transactionDateString",
          label: "Queued Date",
        },
        {
          key: "actionTakenBy",
          label: "Action Taken By",
        },
        {
          key: "actionDescription",
          label: "Status",
        },
        {
          key: "remark",
          label: "Remark",
        },
      ],
      refundHistoryfield: [
        {
          key: "startDate",
          label: "Date",
        },
        {
          key: "changedBy",
          label: "Action Taken By",
        },
        {
          key: "description",
          label: "Action taken Description",
        },
        {
          key: "refundStatus",
          label: "Refund Status",
        },
      ],
      currencyOptions: [{ value: null, text: "--select a Currency--" }],
      countryOptions: [{ value: null, text: "--select a Country--" }],
      paidPaymentOptions: [
        { value: 0, text: "--select Paid Payment Option--" },
      ],
      refundedPaymentOptions: [
        { value: 0, text: "--select Paid Payment Option--" },
      ],
      refundStatusOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Submitted" },
        { value: "3", text: "Approved" },
        { value: "4", text: "Sent" },
        { value: "8", text: "Cancelled" },
        { value: "5", text: "Rejected" },
        { value: "6", text: "Completed" },
      ],
      selectedPaidPaymentOptions: 0,
      selectedRefundedPaymentOptions: 0,
      selectedRefundStatus: 0,
      refundReferenceCodeFromBank: "",
      fromRequestedAmount: 0,
      toRequestedAmount: 0,
      selectedCurrency: "ETB",
      searchTerm: "",
      refundworkflowHistory: [],
      refundhistories: [],
      cancelRefundField: {
        Id: 0,
        cancelRemark: "",
      },
      completeRefundRequestfield: {
        Id: 0,
        RefundReferenceCodeFromBank: "",
        RefundFOP: "",
      },
      sheets: [{ name: "Detail Refund Requests", data: [] }],
    };
  },

  created() {
    if (this.proprefundHistory) {
      this.filterPropRefundRequests();
    }
    this.fetchallPaymentOptions();
    this.fetchRefundRequests();
  },
  methods: {
    getByCountry() {
      this.isLoading = true;
      (this.currencyOptions = [{ value: null, text: "--select a Currency--" }]),
        this.$store.dispatch("config/getActionPrivilege", "Order-Create");
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          res.countries.filter((f) => {
            if (f.countryCode == this.country) {
              f.currencies.forEach((item) => {
                this.currencyOptions.push({
                  value: item.currencyCode,
                  text: item.currencyName,
                });
              });
            }
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=0",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.refundedPaymentOptions.push({
              value: item.paymentOptionId,
              text: item.name,
            });
            this.paidPaymentOptions.push({
              value: item.paymentOption,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          res.countries.forEach((item) => {
            this.countryOptions.push({
              value: item.countryCode,
              text: item.countryName,
            });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    fetchRefundRequests() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Refund-Request");
      axios
        .get("/Order/api/V1.0/Refund/GetRefundRequests")
        .then((res) => {
          this.rows = [];
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.refundRequests;
          res.refundRequests.map((m) => {
            this.sheets[0].data.push({
              "Refund Requested Date": m.refundRequestedDateString,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              "Custom Order Code": m.customOrderCode,
              "Fly Gate OrderId": m.flyGateOrderId,
              "Refund FOP": m.refundFOP,
              "Refund Reference Code": m.refundReferenceCode,
              "Refund Merchant RequestCode": m.refundMerchantRequestCode,
              "Ticket Number": m.originalTicketNumber,
              "Refund Document Number": m.refundDocumentNumber,
              "order Amount": m.orderAmount,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Bank Refund reference": m.refundReferenceCodeFromBank,
              "Refund Status":
                m.refundStatus == 0
                  ? "Refund Not Requested"
                  : m.refundStatus == 1
                  ? "Refund Pending"
                  : m.refundStatus == 2
                  ? "Refund Submitted"
                  : m.refundStatus == 3
                  ? "Refund Approved"
                  : m.refundStatus == 4
                  ? "Refund Sent"
                  : m.refundStatus == 5
                  ? "Refund Rejected"
                  : m.refundStatus == 6
                  ? "Refund Completed"
                  : null,
            });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${err.data.message}`,
            },
          });
          this.isLoading = false;
        });
    },
    filterRefundRequests() {
      this.$store.dispatch("config/getActionPrivilege", "Refund-Request");
      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }
      if (this.trxnDateRangePaidDate !== "") {
        const [trxnSttDatePaidDate, trxnEdDatePaidDate] =
          this.trxnDateRangePaidDate.split(" to ");

        if (this.trxnDateRangePaidDate.includes("to")) {
          this.trxnStartDatePaidDate = trxnSttDatePaidDate;
          this.trxnEndDatePaidDate = trxnEdDatePaidDate;
        } else {
          this.trxnStartDatePaidDate = this.trxnDateRangePaidDate;
          this.trxnEndDatePaidDate = this.trxnDateRangePaidDate;
        }
      }

      const url = `/Order/api/V1.0/Refund/FilterRefundRequests?flyGateOrderId=${
        this.filterflyGateOrderId
      }&vendorTxnRefNumber=${this.filtervendorTxnRefNumber}&customOrderCode=${
        this.filtercustomOrderCode
      }&refundReferenceCode=${
        this.filterrefundReferenceCode
      }&refundMerchantRequestCode=${
        this.filterrefundMerchantRequestCode
      }&fromRefundRequestedDate=${this.trxnStartDate}&toRefundRequestedDate=${
        this.trxnEndDate
      }&paidFOP=${
        this.selectedPaidPaymentOptions
      }&refundedFOP=${this.selectedRefundedPaymentOptions.toString()}&fromPaidDate=${
        this.trxnStartDatePaidDate
      }&toPaidDate=${this.trxnEndDatePaidDate}&refundStatus=${
        this.selectedRefundStatus
      }&fromRequestedAmount=${this.fromRequestedAmount}&toRequestedAmount=${
        this.toRequestedAmount
      }&refundReferenceCodeFromBank=${
        this.refundReferenceCodeFromBank
      }&Currency=${this.currency}&Country=${this.country}`;

      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.refundRequests;
          res.refundRequests.map((m) => {
            //console.log(refund ? refund.OriginalTicketNumber : null);
            this.sheets[0].data.push({
              "Refund Requested Date": m.refundRequestedDateString,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              Email: m.email,
              "Custom Order Code": m.customOrderCode,
              "Fly Gate OrderId": m.flyGateOrderId,
              "Refund FOP": this.refundedPaymentOptions.filter(
                (f) => f.value == m.refundFOP,
              )[0]?.text,
              "Refund Reference Code": m.refundReferenceCode,
              "Refund Merchant RequestCode": m.refundMerchantRequestCode,
              "Ticket Number": m.originalTicketNumber,
              "Refund Document Number": m.refundDocumentNumber,
              "order Amount": m.orderAmount,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Bank Refund reference": m.refundReferenceCodeFromBank,
              "Refund Status":
                m.refundStatus == 0
                  ? "Refund Not Requested"
                  : m.refundStatus == 1
                  ? "Refund Pending"
                  : m.refundStatus == 2
                  ? "Refund Submitted"
                  : m.refundStatus == 3
                  ? "Refund Approved"
                  : m.refundStatus == 4
                  ? "Refund Sent"
                  : m.refundStatus == 5
                  ? "Refund Rejected"
                  : m.refundStatus == 6
                  ? "Refund Completed"
                  : null,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
          this.rows = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
    filterPropRefundRequests() {
      const url = `/Order/api/V1.0/Refund/FilterRefundRequests?flyGateOrderId=${this.proprefundHistory.orderId}&vendorTxnRefNumber=${this.proprefundHistory.vendorTxnRefNumber}&customOrderCode=${this.proprefundHistory.customOrderCode}&refundReferenceCode=&refundMerchantRequestCode=&fromRefundRequestedDate=&toRefundRequestedDate=&paidFOP=&refundedFOP=&fromPaidDate=&toPaidDate=&refundStatus=&fromRequestedAmount=&toRequestedAmount=&refundReferenceCodeFromBank=`;

      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.refundRequests;
          res.refundRequests.map((m) => {
            this.sheets[0].data.push({
              "Refund Requested Date": m.refundRequestedDateString,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              Email: m.email,
              "Custom Order Code": m.customOrderCode,
              "Fly Gate OrderId": m.flyGateOrderId,
              "Refund Merchant RequestCode": m.refundMerchantRequestCode,
              "Refund Reference Code": m.refundReferenceCode,
              "Paid FOP": m.paidFOP,
              "Paid Date": m.paidDate,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Refund Status": m.refundStatus,
              "Refund Initiated By": m.refundInitiatedBy,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.rows = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
    fetchRefundHistory(row) {
      this.isLoading = true;
      axios
        .get(`/Order/api/V1.0/Refund/GetRefundHistory?RequestId=${row.id}`)
        .then((res) => {
          this.isLoading = false;
          //EM140165766325
          console.log(this.refundhistories);
          this.$bvModal.show("modal-Refund-history");
          this.refundhistories = res.refundHistory;
          this.refundhistories.push(row.flyGateOrderId);
          this.refundhistories.map((m) =>
            m.refundStatus == 0
              ? (m.refundStatus = "Refund Not Requested")
              : m.refundStatus == 1
              ? (m.refundStatus = "Refund Pending")
              : m.refundStatus == 2
              ? (m.refundStatus = "Refund Submitted")
              : m.refundStatus == 3
              ? (m.refundStatus = "Refund Approved")
              : m.refundStatus == 4
              ? (m.refundStatus = "Refund Sent")
              : m.refundStatus == 5
              ? (m.refundStatus = "Refund Rejected")
              : m.refundStatus == 6
              ? (m.refundStatus = "Refund Completed")
              : null,
          );
          console.log(this.refundhistories);
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    fetchRefundWorkFLowHistory(row) {
      this.isLoading = true;
      axios
        .get(
          `/Order/api/V1.0/Refund/GetOrderRefundWorkflowHistory?refundRequestId=${row.id}`,
        )
        .then((res) => {
          this.isLoading = false;
          console.log(this.refundworkflowHistory);
          this.$bvModal.show("modal-Refund-workflow-history");
          this.refundworkflowHistory = res.refundWorkFlowHistories;
          this.refundworkflowHistory.push(row.flyGateOrderId);
          console.log(this.refundworkflowHistory);
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    completeRefundRequest(row) {
      this.completeRefundRequestfield.Id = row.id;
      this.completeRefundRequestfield.RefundFOP =
        this.refundedPaymentOptions.filter((f) => f.text == row.paidFOP);
      this.completeRefundRequestfield.RefundFOP =
        this.completeRefundRequestfield.RefundFOP[0].value.toString();
      this.$bvModal.show("modal-complete-refund-request");
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.submitcompleteRefundRequest();
    },
    submitcompleteRefundRequest() {
      if (this.$refs.completeform.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-complete-refund-request");
        });

        this.$bvModal
          .msgBoxConfirm(
            `Are You Sure You Want to Complete the Refund Request?`,
            {
              title: "Warning",
              size: "sm",
              buttonSize: "sm",
              headerBgVariant: "warning",
              cancelTitle: "NO",
              cancelVariant: "warning",
              okVariant: "primary",
              okTitle: "YES",
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
            },
          )
          .then((value) => {
            if (value) {
              this.isLoading = true;
              this.$store.dispatch(
                "config/getActionPrivilege",
                "Refund-CompleteAction",
              );
              console.log(
                typeof this.completeRefundRequestfield.RefundFOP.toString(),
              );
              axios
                .post(
                  `Order/api/V1.0/Refund/RefundCompletedAction`,
                  this.completeRefundRequestfield,
                )
                .then((res) => {
                  this.isLoading = false;
                  this.$bvModal.msgBoxOk("Data was submitted successfully", {
                    title: "Confirmation",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  });
                  this.fetchRefundRequests();
                })
                .catch((res) => {
                  this.isLoading = false;
                  console.log(res);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.data.message}`,
                    },
                  });
                  // this.$refs.loginForm.setErrors(error)
                });
            }
          });
      }
    },
    resendRefundConfirmationMerchant(id) {
      this.$bvModal
        .msgBoxConfirm(` You Want to send refund confirmation to Merchants?`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          headerBgVariant: "warning",
          cancelTitle: "NO",
          cancelVariant: "warning",
          okVariant: "primary",
          okTitle: "YES",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            this.$store.dispatch(
              "config/getActionPrivilege",
              "Refund-CompleteAction",
            );
            axios
              .get(`/Order/api/V1.0/Refund/ResendRefundConfirmation?Id=${id}`)
              .then((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(
                  "Refund Confirmation Resend successfully",
                  {
                    title: "Confirmation",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  },
                );
                this.fetchRefundRequests();
              })
              .catch((res) => {
                this.isLoading = false;
                console.log(res);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    resendRefundConfirmationBank(row) {
      this.$bvModal
        .msgBoxConfirm(` You Want to send refund confirmation to Bank?`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          headerBgVariant: "warning",
          cancelTitle: "NO",
          cancelVariant: "warning",
          okVariant: "primary",
          okTitle: "YES",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            this.$store.dispatch(
              "config/getActionPrivilege",
              "Refund-CompleteAction",
            );
            axios
              .get(
                `/Order/api/V1.0/Refund/ResendRefundRequestToBank?merchantRefundReferenceCode=${row.refundMerchantRequestCode}`,
              )
              .then((res) => {
                this.isLoading = false;
                this.$swal({
                  icon: "info",
                  title: res.message,
                  customClass: {
                    confirmButton: "btn btn-info",
                  },
                }).then((res) => {
                  this.fetchRefundRequests();
                });
              })
              .catch((res) => {
                this.isLoading = false;
                console.log(res);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    cancelRefund(row) {
      this.cancelRefundField.Id = row.id;
      this.$bvModal.show("modal-cancel-refund");
    },
    submitCancelRefund(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (this.$refs.completeform.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-complete-refund-request");
        });
        this.isLoading = true;
        this.$store.dispatch(
          "config/getActionPrivilege",
          "Refund-CompleteAction",
        );
        axios
          .post(`/Order/api/V1.0/Refund/CancelRefund`, this.cancelRefundField)
          .then((res) => {
            this.isLoading = false;
            this.$swal({
              icon: "success",
              title: res.message,
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then((res) => {
              this.fetchRefundRequests();
              this.cancelRefundField.cancelRemark = "";
            });
          })
          .catch((res) => {
            this.isLoading = false;
            this.cancelRefundField.cancelRemark = "";
            console.log(res);
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: `${res.data.message}`,
              },
            });
            // this.$refs.loginForm.setErrors(error)
          });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
